import { parseISO } from 'date-fns'
import dayjs from 'dayjs'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import api from '../../../api'
import Responsive from '../../../assets/config/Responsive'
import Colors from '../../../assets/styles/Colors'
import Loader from '../../../components/Loader'
import BackgroundIcon from '../../../components/v2/BackgroundIcon'
import DatePicker from '../../../components/v2/DatePicker'
import InfoMessage from '../../../components/v2/InfoMessage'
import Message from '../../../components/v2/Message'
import RemainingCompanies from '../../../components/v2/RemainingCompanies'
import ScreenHeader from '../../../components/v2/ScreenHeader'
import Title from '../../../components/v2/Title'
import NavigationButton from '../../../components/v2/buttons/NavigationButton'
import TplProgressbar from '../../../components/v2/progrees-bars/TplProgressbar'
import { useAppDispatch, useAppSelector } from '../../../store'
import { TplState, setDates, setUpdateCarCountdown } from '../../../store/tplSlice'
import { Helmet } from 'react-helmet-async'
import { AppState, clearPhoneInfo } from '../../../store/appSlice'

const ChooseDays = () => {
  //
  const { t } = useTranslation()
  //
  const navigate = useNavigate()
  //
  const dispatch = useAppDispatch()
  //
  const { lang } = useAppSelector((root: { app: AppState }) => root.app)
  //
  const { data: insurancePeriod, isLoading: isInsurancePeriodLoading } =
    api.useGetTplInsurancePeriodDataQuery(undefined)
  //
  //
  //
  const pageTitle = insurancePeriod?.translations[lang]?.title
  const stepName = insurancePeriod?.translations[lang]?.stepName
  //
  //
  const datesIsValid = (start: any, end: any) => {
    const startDateObj = dayjs(start)
    const endDateObj = dayjs(end)

    if (startDateObj.isValid() && endDateObj.isValid()) {
      return startDateObj.isBefore(endDateObj)
    }

    return false
  }
  //
  //
  const { filter, screenHeader } = useAppSelector((data: { tpl: TplState }) => data.tpl)
  //
  //
  const maxDate = dayjs(filter.dates?.start).add(365, 'day').format('YYYY-MM-DD')
  //
  //
  //
  const { data: tplLeftCompanies } = api.useGetTplLeftCompaniesQuery(
    {
      stepName: 'one',
      query: `ProductCategorySlug=${filter.productCategory}&StartDate=${filter.dates?.start}&EndDate=${filter.dates?.end}`,
    },
    { skip: filter.dates?.start ? false : true, refetchOnMountOrArgChange: true },
  )
  //
  //
  const listItems = insurancePeriod?.listItems
  //
  //
  const firstItem = listItems?.[0]
  //
  //
  const mainLoading = isInsurancePeriodLoading
  //
  //
  return mainLoading ? (
    <Loader />
  ) : (
    <Wrapper>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageTitle} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>

      <ScreenHeader totalCount={screenHeader.totalCount} passedCount={screenHeader.passedCount} />

      <Content>
        <Title text={pageTitle} />

        <TplProgressbar stepName={stepName} />

        <FlexBlock>
          <WhiteBox>
            <DatePicker
              minDate={new Date()}
              className="start-date-class"
              label={`${t('startDate')}`}
              dateFormat="dd MMMM yyyy"
              maxDate={parseISO(maxDate) || null}
              selectedDate={filter.dates?.start ? parseISO(filter.dates.start as string) : null}
              onchange={(value) => {
                //
                const startDate = dayjs(value).format('YYYY-MM-DD')
                const endDate = dayjs(value).add(365, 'day').format('YYYY-MM-DD')
                const diffInDays = dayjs(endDate).diff(startDate, 'day')
                //
                if (startDate && endDate && diffInDays) {
                  return dispatch(
                    setDates({
                      start: startDate,
                      end: endDate,
                      days: diffInDays,
                    }),
                  )
                }
              }}
            />

            <br />

            {filter.dates?.start &&
            filter.dates?.end &&
            datesIsValid(filter.dates?.start, filter.dates?.end) === false ? (
              <Message text="დაწყების თარიღი წინ არ უნდა უსწრებდეს დასრულების თარიღს" variant="light-red" />
            ) : null}
          </WhiteBox>

          {filter.dates?.start && (
            <InfoMessage
              style={{
                maxWidth: '464px',
                marginTop: '24px',
              }}
              background="gray"
              variant="info"
              title={firstItem?.title}
              text={firstItem?.body}
            />
          )}

          <RemainingCompanies
            style={{
              opacity: tplLeftCompanies ? '1' : '0',
            }}
            text={`${t('offerAvailable')}: ${tplLeftCompanies?.companiesCount} `}
          />
        </FlexBlock>

        <Buttons>
          <NavigationButton text={`${t('back')}`} buttonType="prev" onClick={() => navigate('/category')} />
          <NavigationButton
            text={`${t('next')}`}
            buttonType="next"
            disabled={
              filter.productCategory &&
              filter.dates?.start &&
              filter.dates?.end &&
              filter.dates?.days &&
              tplLeftCompanies &&
              tplLeftCompanies.companiesCount >= 1
                ? false
                : true
            }
            onClick={() => [
              dispatch(clearPhoneInfo()),
              navigate('/tpl-which-currency'),
              dispatch(
                setUpdateCarCountdown({
                  minute: 0,
                  second: 0,
                }),
              ),
            ]}
          />
        </Buttons>
      </Content>

      <BackgroundIcon />
    </Wrapper>
  )
}
//
//
const WhiteBox = styled.div`
  background-color: ${Colors.white};
  box-shadow: 0 4px 50px 0 ${Colors.shadow};
  border-radius: 8px;
  padding: 40px 48px;
  width: 100%;

  .react-datepicker-wrapper {
    width: 100%;
  }

  .react-datepicker-popper {
    position: unset !important;
    transform: unset !important;
    margin-top: 10px;
  }
  .react-datepicker {
    display: flex;
    justify-content: center;
  }

  ${Responsive.mobile} {
    padding: 32px 20px;
    margin-bottom: 24px;

    &:first-child {
      margin-top: 24px;
      margin-bottom: 20px;
    }
  }
`

const FlexBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 464px;
  width: 100%;
  margin-top: 32px;

  ${Responsive.mobile} {
    margin-top: 24px;
  }
`

const Buttons = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-inline: auto;
  width: 100%;
  margin-top: 48px;
  max-width: 368px;

  button {
    width: 100%;
    padding-inline: 0px;
    &:first-child {
      margin-right: 20px;
    }
  }

  ${Responsive.mobile} {
    max-width: 296px;
    margin-top: 40px;
    button {
      &:first-child {
        margin-right: 15px;
      }
    }
  }
`
const Content = styled.div`
  margin-top: 58px;
  z-index: 2;
  padding-inline: 20px;
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  ${Responsive.mobile} {
    margin-top: 26px;
  }
`
const Wrapper = styled.div`
  min-height: 100vh;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  background-color: ${Colors.backgroundGrey};
  padding-bottom: 20px;
  user-select: none;
  /*  */
`
export default ChooseDays
